module.exports = __webpack_public_path__ + "media/assets/good_at/js-dbc3ba87d600ededcf5ce96dc065e783.png";